module.exports = __webpack_public_path__ + "static/img/newsletter-image-info.0435cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsletter-image-info.png
// module id = Vjp6
// module chunks = 1